<template>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div 
      class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity"
    ></div>

    <div class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex min-h-screen items-center justify-center p-4">
        <div class="relative transform bg-white rounded-lg shadow-xl max-w-md w-full transition-all duration-300 scale-100 opacity-100">
          <div class="p-6">
            <div class="text-center">
              <span class="material-icons text-green-500 text-5xl mb-4">check_circle</span>
              <h3 class="text-xl font-semibold text-gray-900 mb-3">
                {{ title }}
              </h3>
              <p class="text-gray-600 mb-6">
                {{ message }}
              </p>
            </div>
          </div>

          <div class="bg-gray-50 px-6 py-4 rounded-b-lg flex justify-center gap-3">
            <router-link
              to="/PDFS"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors flex items-center gap-2"
            >
              <span class="material-icons text-xl">picture_as_pdf</span>
              Ver PDFs
            </router-link>
            <button
              @click="$emit('continue')"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors flex items-center gap-2"
            >
              <span class="material-icons text-xl">checklist</span>
              Seguir Completando
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Success!'
    },
    message: {
      type: String,
      required: true
    }
  },
  emits: ['continue']
}
</script>
